<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import TableLoading from "@/components/ipos/table-loading";
import TableEmpty from "@/components/ipos/table-empty";
import appConfig from "@/app.config";
import UtilsMixin from "@/mixins/utils";
import Multiselect from "vue-multiselect";
import ConstantMixin from "@/mixins/constants";
import { inventoryService } from "@/services/authservice/inventory";
import DatePicker from "vue2-datepicker";
import { brandService } from "@/services/authservice/brand";
import { accountService } from "../../../services/authservice/account";
import { customerService } from "../../../services/authservice/customer";
import PagingMixin from "../../../mixins/paging";
import PrintImport from "@/components/ipos/print-import";
import { commonService } from "@/services/common";

export default {
  page: {
    title: "Nhập hàng",
    meta: [{ name: "description", content: appConfig.description }],
  },
  mixins: [UtilsMixin, ConstantMixin, PagingMixin],
  components: {
    Layout,
    PageHeader,
    TableLoading,
    TableEmpty,
    Multiselect,
    DatePicker,
    PrintImport,
  },
  data() {
    return {
      listData: [],
      title: "Nhập hàng",
      items: [
        {
          text: "Trang chủ",
          href: "/",
        },
        {
          text: "Nhập hàng",
          active: true,
        },
      ],
      fields: [
        { key: "checkbox", label: "Check" },
        { key: "gr_id", label: "Mã phiếu" },
        { key: "gr_time", label: "Thời gian nhập" },
        { key: "export_from_name", label: "Nhãn hàng" },
        { key: "status", label: "Trạng thái" },
        { key: "created_by", label: "Người tạo" },
        { key: "created_at", label: "Ngày tạo" },
        { key: "note", label: "Ghi chú" },
      ],
      fieldsDC: [
        { key: "checkbox", label: "Check" },
        { key: "gr_id", label: "Mã phiếu" },
        { key: "reference_info", label: "Tham chiếu" },
        { key: "created_by", label: "Người tạo" },
        { key: "created_at", label: "Ngày tạo" },
      ],
      fieldsNB: [
        { key: "checkbox", label: "Check" },
        { key: "gr_id", label: "Mã phiếu" },
        { key: "export_from_name", label: "Nơi nhập" },
        { key: "gr_time", label: "Thời gian xuất" },
        { key: "status", label: "Trạng thái" },
        { key: "created_by", label: "Người tạo" },
        { key: "created_at", label: "Ngày tạo" },
      ],
      fieldsTL: [
        { key: "checkbox", label: "Check" },
        { key: "gr_id", label: "Mã phiếu" },
        { key: "export_from_name", label: "Khách hàng" },
        { key: "reference_info", label: "Tham chiếu" },
        { key: "gr_time", label: "Thời gian xuất" },
        { key: "status", label: "Trạng thái" },
        { key: "created_by", label: "Người tạo" },
        { key: "created_at", label: "Ngày tạo" },
      ],
      fieldsKK: [
        { key: "checkbox", label: "Check" },
        { key: "gr_id", label: "Mã phiếu" },
        { key: "export_from_name", label: "Nơi nhập" },
        { key: "gr_time", label: "Thời gian nhập" },
        { key: "status", label: "Trạng thái" },
        { key: "created_by", label: "Người tạo" },
        { key: "created_at", label: "Ngày tạo" },
      ],
      fieldsNTB: [
        { key: "checkbox", label: "Check" },
        { key: "gr_id", label: "Mã phiếu" },
        { key: "export_from_name", label: "Salesman" },
        { key: "gr_time", label: "Thời gian nhập" },
        { key: "status", label: "Trạng thái" },
        { key: "created_by", label: "Người tạo" },
        { key: "created_at", label: "Ngày tạo" },
      ],
      isBusy: false,
      me: {},
      listBrand: [],
      listSalesman: [],
      listCustomer: [],
      listGrType: [
        { id: "NMH", name: "Nhập hàng từ nhãn" },
        { id: "NDC", name: "Nhập điều chỉnh" },
        { id: "NNB", name: "Nhập nội bộ" },
        { id: "NTB", name: "Nhập trưng bày" },
        { id: "NTL", name: "Nhập trả lại" },
        { id: "NKK", name: "Nhập khác" },
      ],
      searchData: {
        grType: { id: "NMH", name: "Nhập hàng từ nhãn" },
        brand: "",
        date: "",
        status: "",
        salesman: "",
        customer: "",
        page: 1,
      },
      showTable: "NMH",
      isBtnLoading: false,
      listStatus: [
        { id: "PENDING", name: "Chờ xác nhận" },
        { id: "CONFIRMED", name: "Đã xác nhận" },
        { id: "COMPLETED", name: "Đã hoàn thành" },
        { id: "CANCELED", name: "Đã huỷ" },
      ],
      selectedPrintGR: [],
      selectedOrder: [],
      isSelectedAll: false,
      distributorInfo: {},
    };
  },
  beforeMount() {
    this.me = JSON.parse(localStorage.getItem("user"));
    this.getInitData();
  },
  methods: {
    async getInitData() {
      const brandPromise = brandService.getList();
      const salesmanPromise = accountService.getList({ role_id: "SALESMAN" });
      const customerPromise = customerService.getListCustomer();
      const distributorPromise = commonService.getDistributorInfo({
        uid: this.me.distributor_uid,
      });
      // get distributor
      const resDistri = await distributorPromise;
      this.distributorInfo = resDistri.data.data;
      // get list brand
      const resBrand = await brandPromise;
      resBrand.data.data
        ? (this.listBrand = resBrand.data.data)
        : (this.listBrand = []);
      // get list salesman
      const resSalesman = await salesmanPromise;
      resSalesman.data.data
        ? (this.listSalesman = resSalesman.data.data)
        : (this.listSalesman = []);
      // get list customer
      const resCustomer = await customerPromise;
      resCustomer.data.data
        ? (this.listCustomer = resCustomer.data.data)
        : (this.listCustomer = []);
    },

    async getDataDefault() {
      this.currentPage = 1;
      this.totalResult = 0;
      this.totalPage = 1;
      this.perPage = 10;
      let date = new Date();
      const firstDay = new Date(
        date.getFullYear(),
        date.getMonth(),
        1,
        0,
        0,
        0
      );
      const lastDay = new Date(
        date.getFullYear(),
        date.getMonth() + 1,
        0,
        23,
        59,
        59,
        999
      );
      this.searchData = {
        date: [firstDay, lastDay],
        grType: { id: "NMH", name: "Nhập hàng từ nhãn" },
        brand: "",
        status: "",
        salesman: "",
        customer: "",
        page: 1,
      };
      let param = {
        from_timestamp: firstDay.getTime(),
        to_timestamp: lastDay.getTime(),
        gr_type: this.searchData.grType.id,
        warehouse_uid: this.me.warehouse_uid,
        trademark_uid: this.searchData.brand ? this.searchData.brand.id : null,
        created_by: this.searchData.salesman
          ? this.searchData.salesman.email
          : null,
        customer_uid: this.searchData.customer
          ? this.searchData.customer.id
          : null,
        results_per_page: this.perPage,
        page: 1,
      };

      this.showTable = this.searchData.grType.id;
      const res = await inventoryService.getListGoodsReceipt(param);
      if (res.data.error) {
        this.listData = [];
        this.$notify({
          group: "app",
          type: "error",
          title: "Đã có lỗi xảy ra",
          text: res.data.error.message,
        });
      } else {
        this.listData = res.data.data;
        this.totalResult = res.data.num_results;
        this.totalPage = res.data.total_pages;
      }
    },

    async checkParameter() {
      if (this.$route.query.from_timestamp && this.$route.query.to_timestamp) {
        const firstDay = new Date(parseInt(this.$route.query.from_timestamp));
        const lastDay = new Date(parseInt(this.$route.query.to_timestamp));
        this.searchData.date = [firstDay, lastDay];
      }
      if (this.$route.query.gr_type) {
        this.searchData.grType = this.listGrType.find(
          (e) => e.id === this.$route.query.gr_type
        );
      }
      if (this.$route.query.trademark_uid) {
        this.searchData.brand = this.listBrand.find(
          (e) => e.id === this.$route.query.trademark_uid
        );
      }
      if (this.$route.query.status) {
        this.searchData.status = this.listStatus.find(
          (e) => e.id === this.$route.query.status
        );
      }
      if (this.$route.query.created_by) {
        this.searchData.salesman = this.listSalesman.find(
          (e) => e.email === this.$route.query.created_by
        );
      }
      if (this.$route.query.customer_uid) {
        this.searchData.customer = this.listCustomer.find(
          (e) => e.id === this.$route.query.customer_uid
        );
      }
      if (this.$route.query.page) {
        this.searchData.page = this.$route.query.page;
        this.currentPage = this.$route.query.page;
      }
      if (this.$route.query.results_per_page) {
        this.perPage = this.$route.query.results_per_page;
      }
      await this.getDataTable();
    },

    async getDataTable() {
      let param = {
        from_timestamp: this.searchData.date[0]
          ? this.searchData.date[0].getTime()
          : null,
        to_timestamp: this.searchData.date[1]
          ? this.searchData.date[1].getTime()
          : null,
        gr_type: this.searchData.grType.id,
        warehouse_uid: this.me.warehouse_uid,
        trademark_uid: this.searchData.brand ? this.searchData.brand.id : null,
        status: this.searchData.status ? this.searchData.status.id : "",
        created_by: this.searchData.salesman
          ? this.searchData.salesman.email
          : null,
        customer_uid: this.searchData.customer
          ? this.searchData.customer.id
          : null,
        results_per_page: this.perPage,
        page: this.currentPage,
      };

      this.showTable = this.searchData.grType.id;
      const res = await inventoryService.getListGoodsReceipt(param);
      if (res.data.error) {
        this.listData = [];
        this.$notify({
          group: "app",
          type: "error",
          title: "Đã có lỗi xảy ra",
          text: res.data.error.message,
        });
      } else {
        this.listData = res.data.data;
        this.totalResult = res.data.num_results;
        this.totalPage = res.data.total_pages;
      }
    },

    async onSearch(page) {
      this.currentPage = page ? page : 1;
      let start = "";
      let end = "";
      if (
        this.searchData.date.length > 0 &&
        this.searchData.date[0] &&
        this.searchData.date[1]
      ) {
        start = this.searchData.date[0].setHours(0, 0, 0, 0);
        end = this.searchData.date[1].setHours(23, 59, 59, 999);
      }
      const paramShow = {
        from_timestamp: start,
        to_timestamp: end,
        gr_type: this.searchData.grType.id,
        trademark_uid: this.searchData.brand ? this.searchData.brand.id : "",
        status: this.searchData.status ? this.searchData.status.id : "",
        created_by: this.searchData.salesman
          ? this.searchData.salesman.email
          : "",
        customer_uid: this.searchData.customer
          ? this.searchData.customer.id
          : "",
        page: this.currentPage,
        results_per_page: this.perPage,
        ts: new Date().getTime(),
      };

      let strParam = "";
      for (let key in paramShow) {
        if (strParam !== "") {
          strParam += "&";
        }
        strParam += key + "=" + encodeURIComponent(paramShow[key]);
      }
      this.$router.push(`?${strParam}`, () => {
        console.log("Request seach...");
      });
    },

    async onResetSearch() {
      this.$router.push("/inventory/import", () => {
        console.log("Reset default");
      });
    },

    // Chọn in từng phiếu
    onSelectOrder(id) {
      this.selectedPrintGR = this.listData.filter((e) => id.includes(e.id));
    },

    // Chọn in all phiếu
    onSelectAll(value) {
      this.selectedOrder = [];
      this.selectedPrintGR = [];
      if (value) {
        this.selectedOrder = this.listData.map((e) => e.id);
        this.selectedPrintGR = this.listData;
      }
    },

    onPrint() {
      if (this.selectedPrintGR.length > 0) {
        this.$htmlToPaper("importPrint", null, async () => {});
      } else {
        this.$notify({
          group: "app",
          type: "warn",
          title: "Vui lòng chọn phiếu để in",
        });
      }
    },
  },

  watch: {
    $route: {
      // lắng nghe route thay đổi param, nếu thay đổi sẽ thực thi theo logic dưới
      handler: async function (from, to) {
        this.isBusy = true;
        this.me = JSON.parse(localStorage.getItem("user"));
        if (from.fullPath === "/inventory/import") {
          // mặc định khi vào màn hình, kiểm tra nếu là route gốc thì gọi init data + data default
          await this.getInitData();
          await this.getDataDefault();
        } else {
          // nếu có param thì filter mặc định search data theo param
          if (!to) {
            // Khi F5 lại check nếu có param thì phải init data
            await this.getInitData();
          }
          await this.checkParameter();
        }
        this.isBusy = false;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card">
      <div class="card-body">
        <!--Search form-->
        <div class="row mb-3">
          <div class="col-12" style="display: contents">
            <div class="form-group mt-0 mb-2 mr-2">
              <multiselect
                class="w200"
                v-model="searchData.grType"
                :options="listGrType"
                track-by="id"
                label="name"
                placeholder="Chọn kiểu xuất"
                noOptions="Danh sách trống"
                :show-labels="false"
              ></multiselect>
            </div>
            <div class="form-group mt-0 mb-0 mr-2">
              <multiselect
                class="w200"
                v-model="searchData.brand"
                :options="listBrand"
                track-by="id"
                label="trademark_name"
                placeholder="Chọn nhãn hàng"
                noOptions="Danh sách trống"
                :show-labels="false"
              ></multiselect>
            </div>
            <div class="form-group mt-0 mb-0 mr-2">
              <multiselect
                class="w200"
                v-model="searchData.salesman"
                :options="listSalesman"
                track-by="id"
                label="name"
                placeholder="Chọn Salesman"
                noOptions="Danh sách trống"
                :show-labels="false"
              ></multiselect>
            </div>
            <div class="form-group mt-0 mb-0 mr-2">
              <multiselect
                class="w200"
                v-model="searchData.customer"
                :options="listCustomer"
                track-by="id"
                label="customer_name"
                placeholder="Chọn khách hàng"
                noOptions="Danh sách trống"
                :show-labels="false"
              >
                <template slot="option" slot-scope="props">
                  <div>
                    <span class="option__title font-weight-bold">{{
                      props.option.customer_name
                    }}</span>
                    <br />
                    <span v-if="props.option.customer_phone"
                      >- SĐT: {{ props.option.customer_phone }}<br
                    /></span>

                    <span v-if="props.option.customer_address"
                      >- Địa chỉ: {{ props.option.customer_address }}</span
                    >
                  </div>
                </template>
              </multiselect>
            </div>
            <div class="form-group mt-0 mb-0 mr-2 min-w-200">
              <date-picker
                v-model="searchData.date"
                :first-day-of-week="1"
                lang="en"
                range
                format="DD/MM/YYYY"
                placeholder="Chọn khoảng thời gian"
                :shortcuts="shortcuts"
              ></date-picker>
            </div>
            <div class="form-group mt-0 mb-0 mr-2">
              <multiselect
                class="w200"
                v-model="searchData.status"
                :options="listStatus"
                track-by="id"
                label="name"
                placeholder="Chọn trạng thái"
                noOptions="Danh sách trống"
                :show-labels="false"
              ></multiselect>
            </div>
            <div class="mt-0">
              <button
                type="button"
                class="btn btn-primary"
                @click="onSearch(1)"
              >
                Lọc
              </button>
              <button
                type="button"
                class="ml-2 btn btn-secondary"
                @click="onResetSearch"
              >
                <i class="bx bx-revision"></i>
              </button>
            </div>
          </div>
        </div>
        <!-- Datatable -->
        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center">
                Hiện
                <b-form-select
                  @change="onSearch(1)"
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                ></b-form-select
                >&nbsp;mục
              </label>
            </div>
          </div>
          <!-- Add new -->
          <div class="col-sm-12 col-md-6">
            <div class="row mb-2">
              <div class="col-lg-12">
                <div class="d-flex justify-content-end">
                  <button
                    @click="onPrint"
                    type="button"
                    class="btn btn-light mr-2"
                  >
                    <i class="bx bx-printer font-size-16 align-middle mr-2"></i>
                    In phiếu
                  </button>
                  <router-link
                    class="btn btn-label btn-primary"
                    to="/inventory/import/create"
                  >
                    <i class="bx bx-plus label-icon"></i> Thêm mới
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <!-- End add new -->
        </div>
        <div v-if="showTable === 'NMH'" class="table-responsive mb-0">
          <b-table
            show-empty
            :items="listData"
            :fields="fields"
            responsive="sm"
            :busy="isBusy"
            table-class="scroll-table"
          >
            <template v-slot:table-busy>
              <TableLoading />
            </template>
            <template v-slot:empty>
              <TableEmpty />
            </template>
            <template v-slot:cell(index)="row">
              {{ row.index + 1 }}
            </template>
            <template v-slot:head(checkbox)="row">
              <b-form-checkbox
                @change="onSelectAll($event)"
                v-model="isSelectedAll"
                name="selected-order"
              ></b-form-checkbox>
            </template>
            <template v-slot:cell(checkbox)="row">
              <b-form-checkbox
                :id="row.item.id"
                v-model="selectedOrder"
                @change="onSelectOrder($event)"
                name="selected-order"
                :key="row.item.id"
                :value="row.item.id"
              ></b-form-checkbox>
            </template>
            <template v-slot:cell(gr_id)="row">
              <router-link
                :to="{
                  name: 'InventoryImportDetail',
                  params: { id: row.item.id },
                }"
              >
                {{ row.item.gr_id }}
              </router-link>
            </template>
            <template v-slot:cell(gr_time)="row">
              {{ formatDate(row.item.gr_time) }}
            </template>
            <template v-slot:cell(created_at)="row">
              {{ formatDateUnix(row.item.created_at) }}
            </template>
            <template v-slot:cell(status)="row">
              <span
                class="badge badge-pill p-2 text-uppercase"
                :class="renderStatus(row.item.status)[1]"
              >
                {{ renderStatus(row.item.status)[0] }}
              </span>
            </template>
          </b-table>
        </div>
        <div v-if="showTable === 'NDC'" class="table-responsive mb-0">
          <b-table
            show-empty
            :items="listData"
            :fields="fieldsDC"
            responsive="sm"
            :busy="isBusy"
            table-class="scroll-table"
          >
            <template v-slot:table-busy>
              <TableLoading />
            </template>
            <template v-slot:empty>
              <TableEmpty />
            </template>
            <template v-slot:cell(index)="row">
              {{ row.index + 1 }}
            </template>
            <template v-slot:head(checkbox)="row">
              <b-form-checkbox
                @change="onSelectAll($event)"
                v-model="isSelectedAll"
                name="selected-order"
              ></b-form-checkbox>
            </template>
            <template v-slot:cell(checkbox)="row">
              <b-form-checkbox
                :id="row.item.id"
                v-model="selectedOrder"
                @change="onSelectOrder($event)"
                name="selected-order"
                :key="row.item.id"
                :value="row.item.id"
              ></b-form-checkbox>
            </template>
            <template v-slot:cell(gr_id)="row">
              <router-link
                :to="{
                  name: 'InventoryImportDetail',
                  params: { id: row.item.id },
                }"
              >
                {{ row.item.gr_id }}
              </router-link>
            </template>
            <template v-slot:cell(reference_info)="row">
              <router-link
                v-if="
                  row.item.reference_info && row.item.reference_info.length > 0
                "
                target="_blank"
                :to="{
                  name: 'InventoryCheckDetail',
                  params: { id: row.item.reference_info[0].document_uid },
                }"
              >
                {{ row.item.reference_info[0].document_id }}
              </router-link>
            </template>
            <template v-slot:cell(gr_time)="row">
              {{ formatDateUnix(row.item.gr_time) }}
            </template>
            <template v-slot:cell(created_at)="row">
              {{ formatDateUnix(row.item.created_at) }}
            </template>
            <template v-slot:cell(status)="row">
              <span
                class="badge badge-pill p-2 text-uppercase"
                :class="renderStatus(row.item.status)[1]"
              >
                {{ renderStatus(row.item.status)[0] }}
              </span>
            </template>
          </b-table>
        </div>
        <div v-if="showTable === 'NNB'" class="table-responsive mb-0">
          <b-table
            show-empty
            :items="listData"
            :fields="fieldsNB"
            responsive="sm"
            :busy="isBusy"
            table-class="scroll-table"
          >
            <template v-slot:table-busy>
              <TableLoading />
            </template>
            <template v-slot:empty>
              <TableEmpty />
            </template>
            <template v-slot:cell(index)="row">
              {{ row.index + 1 }}
            </template>
            <template v-slot:head(checkbox)="row">
              <b-form-checkbox
                @change="onSelectAll($event)"
                v-model="isSelectedAll"
                name="selected-order"
              ></b-form-checkbox>
            </template>
            <template v-slot:cell(checkbox)="row">
              <b-form-checkbox
                :id="row.item.id"
                v-model="selectedOrder"
                @change="onSelectOrder($event)"
                name="selected-order"
                :key="row.item.id"
                :value="row.item.id"
              ></b-form-checkbox>
            </template>
            <template v-slot:cell(gr_id)="row">
              <router-link
                :to="{
                  name: 'InventoryImportDetail',
                  params: { id: row.item.id },
                }"
              >
                {{ row.item.gr_id }}
              </router-link>
            </template>
            <template v-slot:cell(gr_time)="row">
              {{ formatDateUnix(row.item.gr_time) }}
            </template>
            <template v-slot:cell(gi_id)="row">
              <router-link
                :to="{
                  name: 'InventoryExportDetail',
                  params: { id: row.item.id },
                }"
              >
                {{ row.item.gi_id }}
              </router-link>
            </template>
            <template v-slot:cell(created_at)="row">
              {{ formatDateUnix(row.item.created_at) }}
            </template>
            <template v-slot:cell(status)="row">
              <span
                class="badge badge-pill p-2 text-uppercase"
                :class="renderStatus(row.item.status)[1]"
              >
                {{ renderStatus(row.item.status)[0] }}
              </span>
            </template>
          </b-table>
        </div>
        <div v-if="showTable === 'NTB'" class="table-responsive mb-0">
          <b-table
            show-empty
            :items="listData"
            :fields="fieldsNTB"
            responsive="sm"
            :busy="isBusy"
            table-class="scroll-table"
          >
            <template v-slot:table-busy>
              <TableLoading />
            </template>
            <template v-slot:empty>
              <TableEmpty />
            </template>
            <template v-slot:cell(index)="row">
              {{ row.index + 1 }}
            </template>
            <template v-slot:head(checkbox)="row">
              <b-form-checkbox
                @change="onSelectAll($event)"
                v-model="isSelectedAll"
                name="selected-order"
              ></b-form-checkbox>
            </template>
            <template v-slot:cell(checkbox)="row">
              <b-form-checkbox
                :id="row.item.id"
                v-model="selectedOrder"
                @change="onSelectOrder($event)"
                name="selected-order"
                :key="row.item.id"
                :value="row.item.id"
              ></b-form-checkbox>
            </template>
            <template v-slot:cell(gr_id)="row">
              <router-link
                :to="{
                  name: 'InventoryImportDetail',
                  params: { id: row.item.id },
                }"
              >
                {{ row.item.gr_id }}
              </router-link>
            </template>
            <template v-slot:cell(gr_time)="row">
              {{ formatDateUnix(row.item.gr_time) }}
            </template>
            <template v-slot:cell(created_at)="row">
              {{ formatDateUnix(row.item.created_at) }}
            </template>
            <template v-slot:cell(status)="row">
              <span
                class="badge badge-pill p-2 text-uppercase"
                :class="renderStatus(row.item.status)[1]"
              >
                {{ renderStatus(row.item.status)[0] }}
              </span>
            </template>
          </b-table>
        </div>
        <div v-if="showTable === 'NTL'" class="table-responsive mb-0">
          <b-table
            show-empty
            :items="listData"
            :fields="fieldsTL"
            responsive="sm"
            :busy="isBusy"
            table-class="scroll-table"
          >
            <template v-slot:table-busy>
              <TableLoading />
            </template>
            <template v-slot:empty>
              <TableEmpty />
            </template>
            <template v-slot:cell(index)="row">
              {{ row.index + 1 }}
            </template>
            <template v-slot:head(checkbox)="row">
              <b-form-checkbox
                @change="onSelectAll($event)"
                v-model="isSelectedAll"
                name="selected-order"
              ></b-form-checkbox>
            </template>
            <template v-slot:cell(checkbox)="row">
              <b-form-checkbox
                :id="row.item.id"
                v-model="selectedOrder"
                @change="onSelectOrder($event)"
                name="selected-order"
                :key="row.item.id"
                :value="row.item.id"
              ></b-form-checkbox>
            </template>
            <template v-slot:cell(gr_id)="row">
              <router-link
                :to="{
                  name: 'InventoryImportDetail',
                  params: { id: row.item.id },
                }"
              >
                {{ row.item.gr_id }}
              </router-link>
            </template>
            <template v-slot:cell(reference_info)="row">
              <div
                v-if="
                  row.item.reference_info && row.item.reference_info.length > 0
                "
              >
                <router-link
                  target="_blank"
                  :to="{
                    name: 'OrderDetail',
                    params: { id: row.item.reference_info[0].document_uid },
                  }"
                >
                  {{ row.item.reference_info[0].document_id }}
                </router-link>
              </div>
            </template>
            <template v-slot:cell(gr_time)="row">
              {{ formatDateUnix(row.item.gr_time) }}
            </template>
            <template v-slot:cell(created_at)="row">
              {{ formatDateUnix(row.item.created_at) }}
            </template>
            <template v-slot:cell(status)="row">
              <span
                class="badge badge-pill p-2 text-uppercase"
                :class="renderStatus(row.item.status)[1]"
              >
                {{ renderStatus(row.item.status)[0] }}
              </span>
            </template>
          </b-table>
        </div>
        <div v-if="showTable === 'NKK'" class="table-responsive mb-0">
          <b-table
            show-empty
            :items="listData"
            :fields="fieldsKK"
            responsive="sm"
            :busy="isBusy"
            table-class="scroll-table"
          >
            <template v-slot:table-busy>
              <TableLoading />
            </template>
            <template v-slot:empty>
              <TableEmpty />
            </template>
            <template v-slot:cell(index)="row">
              {{ row.index + 1 }}
            </template>
            <template v-slot:head(checkbox)="row">
              <b-form-checkbox
                @change="onSelectAll($event)"
                v-model="isSelectedAll"
                name="selected-order"
              ></b-form-checkbox>
            </template>
            <template v-slot:cell(checkbox)="row">
              <b-form-checkbox
                :id="row.item.id"
                v-model="selectedOrder"
                @change="onSelectOrder($event)"
                name="selected-order"
                :key="row.item.id"
                :value="row.item.id"
              ></b-form-checkbox>
            </template>

            <template v-slot:cell(gr_id)="row">
              <router-link
                :to="{
                  name: 'InventoryImportDetail',
                  params: { id: row.item.id },
                }"
              >
                {{ row.item.gr_id }}
              </router-link>
            </template>
            <template v-slot:cell(gr_time)="row">
              {{ formatDateUnix(row.item.gr_time) }}
            </template>
            <template v-slot:cell(created_at)="row">
              {{ formatDateUnix(row.item.created_at) }}
            </template>
            <template v-slot:cell(status)="row">
              <span
                class="badge badge-pill p-2 text-uppercase"
                :class="renderStatus(row.item.status)[1]"
              >
                {{ renderStatus(row.item.status)[0] }}
              </span>
            </template>
          </b-table>
        </div>
        <div class="row mt-3" v-if="!isBusy && listData.length > 0">
          <div class="col">
            <div class="d-flex align-items-center float-right">
              <p class="mr-3 mb-0">{{ detailPaging }}</p>
              <b-pagination
                class="mb-0"
                v-model="currentPage"
                :total-rows="totalResult"
                @change="onChangePage"
                :per-page="perPage"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  Print container  -->
    <div id="importPrint" class="bg-white p-3 text-dark d-none" v-if="!isBusy">
      <PrintImport
        v-for="(gr, i) of selectedPrintGR"
        :key="i"
        :data="gr"
        :me="me"
        :distributor="distributorInfo"
      />
    </div>
    <!-- end row -->
  </Layout>
</template>